import useTable from '@/hooks/useTable';
import { ErrorBlock, LoadingBlock } from '@/components/feature/SectionState';
import type { GsCommunity } from '@/lib/types';
import { juniorSteps } from '@/mocks/home';

export default function Community() {
  const { data: cards, loading, error, reload } = useTable<GsCommunity>('gs_community');

  return (
    <section id="community" className="bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Community</p>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02] mt-3 mb-10">Your Golf Community</h2>

      {loading && <LoadingBlock label="Loading community" />}
      {error && <ErrorBlock message={error} onRetry={reload} />}

      {!loading && !error && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((c) => (
            <article key={c.id} className="group relative h-[440px] md:h-[520px] rounded-lg overflow-hidden">
              <img src={c.image} alt={c.title} title={`${c.title} in Southern California`} className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/10"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <h3 className="font-heading font-bold text-3xl md:text-4xl text-background-50">{c.title}</h3>
                <p className="mt-2 text-background-200 text-sm md:text-base max-w-md">{c.body}</p>
                {c.title === 'Junior Golf Hub' && (
                  <ol className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2">
                    {juniorSteps.map((s, i) => (
                      <li key={s} className="bg-background-50/10 border border-background-50/30 rounded-md p-2.5">
                        <span className="font-heading font-bold text-accent-400 text-xl">0{i + 1}</span>
                        <p className="font-label uppercase text-xs text-background-50 leading-tight mt-1">{s}</p>
                      </li>
                    ))}
                  </ol>
                )}
                <p className="mt-4 pt-3 border-t border-background-50/20 font-label uppercase text-xs tracking-widest text-background-300">Presented by: <span className="text-accent-400">sponsor slot open</span></p>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}